export enum EaDisplay {
  neutral = 'neutral',
  success = 'success',
  danger = 'danger',
  warning = 'warning',
  dark = 'dark',
  light = 'light',
}

export enum EaVariant {
  filled = 'filled',
  colored = 'colored',
  outline = 'outline',
  ghost = 'ghost',
  pills = 'pills',
  crm = 'crm',
}

export enum EaSize {
  xs = 'xs',
  sm = 'sm',
  md = 'md',
  lg = 'lg',
  xl = 'xl',
}
